import { useMemo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { locationOffersFluShot } from '~/core/util/location';

export default (physicalLocation: any) => {
  return useMemo(() => {
    return !isEmpty(physicalLocation) && locationOffersFluShot(physicalLocation);
  }, [physicalLocation]);
};
